@if(loader.isLoading()) {
  <div class="loader">
    <div class="loader__image"></div>
  </div>
}
